















































































import AbpBase from "@/lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {GetListByCode} from "@/api/configureDictionary"
import {
	InsertBedScheduling,
	InsertBedSchedulingTemp,
	UpdateBedScheduling,
	UpdateBedSchedulingTemp
} from "@/api/bedScheduling"
import {GetPatients} from "@/api/specialDictionary"
import ChooseColor from '../../../../components/chooseColor.vue'
import ChooseShape from '../../../../components/chooseShape.vue'

@Component({
	components:{ChooseColor, ChooseShape}
})
export default class Country extends AbpBase {
	@Prop({type: Boolean, default: false}) value: boolean;
	/**
	 * schedule: {},
	 * bed: params.row,
	 * shift: j,
	 * time: i + "/" + w[index],
	 * patients: this.patients
	 * */
	@Prop({type: Object, default: {}}) data: any;

	patientsLoading =false

	dialysisModels = ''

	get dialogTitle() {
		return this.data.bed.wardName + '/' + this.data.bed.bedcode + '/' + this.data.shift.shiftName + "  排床模板"
	}

	colors = ["#FFFFFF", "#FF6600", "#FF02FF",  "#FF0001", "#3365FF", "#33CCCC"]

	flagEnums = ['无', '圆', '三角', '心', '方块']
	flags = ['', '&#xe64f;', '&#xe620;', '&#xe640;', '&#xe600;']
	//<Icon type="ios-square" />

	dialogForm: any = {
		patientId: '',
		dialysisModelCode: '',
		colorEnum: 0,
		flagEnum: 0,
		remark: ''
	}


	pickColor(val: any){
		this.dialogForm.colorEnum = val
	}
	pickShape(val: any){
		this.dialogForm.flagEnum = val
	}

	created() {
		console.log(this.data)
		// if (!!this.data.schedule.id) {
			this.dialogForm.id = this.data.schedule.id || 0
		// }
		this.dialogForm.patientId = this.data.schedule.patientId || ''
		this.dialogForm.dialysisModelCode = this.data.schedule.dialysisModelCode || ''
		this.dialogForm.colorEnum = this.data.schedule.colorEnum || 0
		this.dialogForm.remark = this.data.schedule.remark || ''
		this.dialogForm.flagEnum = this.data.schedule.flagEnum || 0
		this.dialogForm.badId = this.data.bed.id || 0
		this.dialogForm.shiftId = this.data.shift.id || 0
		this.dialogForm.weekDay = this.data.time.split('/')[1]
		this.dialogForm.machineType = ''
		this.dialogForm.weekFlag = this.data.weekFlag
	}

	mounted(){
		this.getSelects()
	}

	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
		}
	}

	async save(){
		(this.$refs.form as any).validate(async (valid:boolean)=>{
			if(valid){
				if (!this.dialogForm.id) {
					let res = await InsertBedSchedulingTemp({
						bedSchedulingTempDto:[this.dialogForm]
						}
					)
				} else {
					let res = await UpdateBedSchedulingTemp(this.dialogForm)
				}
				this.$emit('save-success')
			}
		})
		// let bedSchedulingDto = [this.dialogForm]

	}

	cancel(){
		this.$emit('input', false);
	}

	dialogFormLabelWidth = '120px'

	rules = {
		patientId: [{required: true, message: '请选择患者', trigger: 'blur'}],
		dialysisModelCode: [{required: true, message: '请选择模式', trigger: 'blur'}],
		colorEnum: [{required: true, message: '请输入内容', trigger: 'blur'}],
		flagEnum: [{required: true, message: '请输入内容', trigger: 'blur'}],
	}

	async getPatient(query: any){
		this.patientsLoading = true
		let res = await GetPatients({
			QueryString: query,
			SkipCount: 1,
			MaxResultCount: 1000
		})
		this.data.patients = res.items
		this.patientsLoading = false
	}

	async getSelects() {
		let res = await GetListByCode({input: '025'})
		this.dialysisModels = res
		this.patientsLoading = true
		let res1 = await GetPatients({
			SkipCount: 1,
			MaxResultCount: 10000
		})
		this.data.patients = res1.items
		this.patientsLoading = false
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/bedScheduling/pre/parts/schedule.vue